import { useEffect, useState } from 'react';
import usePrerenderReady from './usePrerenderReady';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '';

export default function usePageContent(pageKey) {
  const [sections, setSections] = useState({});
  const [loading, setLoading] = useState(Boolean(pageKey && API));
  usePrerenderReady(loading);

  useEffect(() => {
    let mounted = true;
    if (!pageKey || !API) return undefined;
    setLoading(true);

    fetch(`${API}/content/pages/${pageKey}`)
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => {
        if (mounted && payload?.page?.sections) {
          setSections(payload.page.sections);
        }
      })
      .catch(() => null)
      .finally(() => { if (mounted) setLoading(false); });

    return () => {
      mounted = false;
    };
  }, [pageKey]);

  return sections;
}
